<template>
  <div class="navigation_block">
    <div
      class="nav_header row"      
      :class="
        !(openDrawer || $store.state.showHoverNavigation) ? 'reducePadding' : ''
      "
    >
      <div
        v-if="openDrawer || $store.state.showHoverNavigation"
        style="height: 27px; width: 185px; margin: 0px;position: absolute;top: 50%;transform: translateY(-50%);"
      >
        <object data="assets/img/gk_logo.svg"></object>
      </div>
      <div v-else style="height: 40px; width: 80%; margin-top: 23px">
        <object data="assets/img/gk-logo-vert-2.svg"></object>
      </div>
    </div>

    <div
      class="open_wrapper"
      @mouseover="expandNavigation();renderDelay()"
      @mouseout="renderDelayCollapseIcon()"
      v-if="true ||openDrawer || $store.state.showHoverNavigation"
    >
      <div
        v-for="(item, index) in menuArray"
        :key="index"
        class="nav_header_item row"
        :class="!(openDrawer || $store.state.showHoverNavigation)?(selectedModule && selectedModule == item['id'] ? 'selected' : ''):''"
      >
        <div style="height: 20px; width: 20px;" :class="!(openDrawer || $store.state.showHoverNavigation)?'close_nav':'open_nav'">
          <object :data="((!(openDrawer || $store.state.showHoverNavigation)) && (selectedModule && selectedModule == item['id'])) ? (('assets/img/' + item['icon'] + '_black' + '.svg')): ('assets/img/' + item['icon'] + '.svg')"
          ></object>
        </div>
        <div class="sub_heading" v-show="(openDrawer || $store.state.showHoverNavigation)">{{ item["name"] }}</div>
        <div
          v-show="(openDrawer || $store.state.showHoverNavigation)"
          v-for="(tab, tab_index) in item['tabs']"
          :key="tab_index"
          class="nav_header_tab"
          @click="tabSelected(tab)"
          @mouseover="tabHovered(tab['id'])"
          @mouseleave="tabUnHovered()"
          :class="
            fetchSelectedTab(currentPage)
              ? ((tab.id == selectedTab)
                ? 'selected'
                : (tab['id']==tabHoveredId ? 'hovered':''))
              : (tab['id']==tabHoveredId?'hovered':'')
          "
        >
          {{ tab["name"] }}
        </div>
      </div>
    </div>
    <!-- collapse footer starts -->
    
    <div
      v-if="!(openDrawer || $store.state.showHoverNavigation)"
      class="collapse"
    >
      <div style="display:inline-grid;padding-left:1px;padding-top:3px" class='fade_in' :class="showHoverIcon?'nav_icon_hovered':'nav_icon_unhovered'">
        <i class="fas fa-angle-right" :style="showHoverIcon ? 'color:#ffffff':'color:#777677'"></i>
      </div>
    </div>
    <div
      v-if="!(openDrawer || $store.state.showHoverNavigation)"
      class="collapse"
      v-on:click="updateDrawer();showHoverIcon=false"
      @mouseenter="showHoverIcon=true"
      @mouseleave="showHoverIcon=false"
    ></div>

    
    <!-- //expand footer starts -->
    
    <!-- //when nav is just hovered, not opened -->
    <div class="expand hover" 
      @mouseover="expandNavigation();"
      v-if="renderDelayVariable && (!this.openDrawer && this.$store.state.showHoverNavigation)">
      <div style="display:inline-grid;padding-left:8px;padding-top:3px" class="fade_in" :class="showHoverIcon?'nav_icon_hovered':'nav_icon_unhovered'">
        <i  :style="showHoverIcon ? 'color:#ffffff':'color:#777677'" class="fas fa-angle-right"></i>
      </div>
    </div>
    
    <!-- //when nav is opened  -->

     <!-- :class="$store.state.showHoverNavigation && openDrawer ? 'fade_in':(!(openDrawer || $store.state.showHoverNavigation) ?'':'')"> -->
     
    <div class="expand open" 
      @mouseover="expandNavigation"
      v-else-if="destroyDelayVariable"
      :class="(showHoverNavigation && (!(!this.openDrawer && this.$store.state.showHoverNavigation)) && ((openDrawer || $store.state.showHoverNavigation)))?'fade_in':((openDrawer || $store.state.showHoverNavigation)?'fade_out':'no_display')"
      >
      <div  style="display:inline-grid;padding-left:6px;padding-top:3px"  :class="showHoverIcon?'nav_icon_hovered':'nav_icon_unhovered'">
        <i :style="showHoverIcon ? 'color:#ffffff':'color:#777677'" class="fas fa-angle-left"></i>
      </div>
    </div>

    <div v-if="$store.state.showHoverNavigation" v-on:click="updateDrawer()" class="expand" @mouseenter="showHoverIcon=true"
      @mouseleave="showHoverIcon=false"
    ></div>
    <div
      class="expand_footer"
      @mouseover="expandNavigation"
      v-if="openDrawer || $store.state.showHoverNavigation"
    >
      <p class="signed_in">SIGNED IN</p>
      <div class="name_example" :class="selectedModule=='nav_footer'?'selected':''">
        <span class="user_name" :class="selectedModule=='nav_footer'?'selected':''">
          {{ userName }}
        </span>
        <i class="fa fa-caret-up fa-lg dropdown-toggle dropdown-toggle-split" :style="selectedModule=='nav_footer'?'color: #000000 !important':''"
         data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="color: #FFFFFF;cursor:pointer" aria-hidden="true"></i>
        <div class="dropdown-menu" id='dropdown_footer'>
          <a class="dropdown-item" @click="tabSelected({id:'resources'});" style="cursor:pointer;">Resources & Updates</a>
					<a class="dropdown-item" @click="tabSelected({id:'templates'});" style="cursor:pointer;">Templates</a>
					<a class="dropdown-item" @click="navigateToLogout" style="cursor:pointer;">Log Out</a>
        </div>
      </div>
      <p class="signature">
        © {{ moment().year() }} Global Overview. All rights reserved
      </p>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Template from "./templates/Template.vue";
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
export default {
  components: { Template },
  data() {
    return {
      showHoverIcon:false,
      userName: "",
      selectedTab: "",
      selectedModule: "",
      tabHoveredId:null,
      menuArray: [
        {
          name: "Reports",
          id: "reports",
          tabs: [{ id: "executive_reporting", name: "Executive Reporting" }],
          icon: "Reports",
        },
        {
          name: "Campaigns",
          id: "campaigns",
          tabs: [
            { id: "campaigns", name: "Campaigns" },
            { id: "dsp", name: "DSP" },
            
            // { id: "campaign_groups", name: "Groups" }, //DISABLING ML RELATED COMPONENT (ENG1-2161)
          ],
          icon: "Campaigns",
        },
        {
          name: "Products",
          id: "products",
          tabs: [
            { id: "products", name: "Products" },
            { id: "asin_scraper", name: "ASIN Scraper" },
            { id: "product_alerts", name: "Product Alerts [beta]" }
          ],
          icon: "Products 2",
        },
        {
          name: "Guardrails",
          id: "guardrails",
          tabs: [
            { id: "my_guardrails", name: "My Guardrails" },
            { id: "all_guardrails", name: "All Guardrails" }
          ],
          icon: "Guardrails",
        },
        {
          name: "Accounts",
          id: "accounts",
          tabs: [
            { id: "acc_management", name: "Account Management" },
            { id: "tagging_strategy", name: "Tagging Strategy" },
          ],
          icon: "Accounts_Opt1",
        },
      ],
    };
  },
  computed: {
    destroyDelayVariable:{
      set(val){
        this.$store.state.destroyDelayVar = val;
      },
      get(){
        return this.$store.state.destroyDelayVar ;
      }
    },
    selectedPage: {
      set(val) {
        this.$store.state.selectedPage = val;
      },
      get() {
        return this.$store.state.selectedPage;
      },
    },
    currentPage() {
      return this.$route.name;
    },
    currentRoute() {
      return this.$route.params;
    },
    openDrawer: {
      set(val) {
        sessionStorage.setItem('openDrawer',val)
        this.$store.state.openDrawer = val;
      },
      get() {
        return this.$store.state.openDrawer;
      },
    },
    showHoverNavigation: {
      set(val) {
        this.$store.state.showHoverNavigation = val;
      },
      get() {
        return this.$store.state.showHoverNavigation;
      },
    },
    renderDelayVariable:{
      set(val){
        this.$store.state.renderDelayVar = val;
      },
      get(){
        return this.$store.state.renderDelayVar;
      }
    }
  },
  mounted() {
    this.userName = JSON.parse(window.localStorage.session).name;
  },
  methods: {
    moment,
    renderDelay(){
      // this.renderDelayVar = false
      if((!this.openDrawer && this.$store.state.showHoverNavigation)){
        // return setTimeout(alert(), 500000);
        setTimeout(() => {
          this.renderDelayVariable = true
        }, 180);
      }
      else{
          // this.renderDelayVariable = false
      }
    },
    renderDelayCollapseIcon(){
      if(this.showHoverNavigation && (!(!this.openDrawer && this.$store.state.showHoverNavigation)) && ((this.openDrawer || this.$store.state.showHoverNavigation))){
        return true
      }
      else{
        setTimeout(()=>{
          this.destroyDelayVariable= false
        }
        , 180);
      }
    },
    navigateToLogout(){
			this.loguserOutFromCognito();
			this.$store.commit('clearSessionData');
			this.$router.push({path:'/login'})
    },
		navigateToReleaseNotes(){
			this.$store.state.release.pathBeforeReleaseNote = this.$route.fullPath;
			this.$router.push({path:'/releaseNotes'})
		},
		navigateToTemplates(){
			this.$store.state.release.pathBeforeReleaseNote = this.$route.fullPath;
			this.$router.push({path:'/template'})
		},
		loguserOutFromCognito(){
			//

			var data = {
				UserPoolId : 'us-east-1_KPh2ycnq4', // Your user pool id here
				ClientId : '1qe6ml4g9dh4c1sl5j99k8965j' // Your client id here
			};

			var userPool = new AmazonCognitoIdentity.CognitoUserPool(data);

			var userData = {
				  Username : JSON.parse(window.localStorage.getItem('session')).username, //'kjoshi@contata.com',
				  Pool : userPool
			  };
			var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
			cognitoUser.signOut()
			sessionStorage.clear();
			localStorage.clear();

		},
    tabHovered(id){
      this.tabHoveredId = id
    },
    tabUnHovered(){
      this.tabHoveredId = null
    },
    updateDrawer() {
      if (this.openDrawer) {
        this.closeDrawerOnClick();
      } else {
        this.openDrawerOnClick();
      }
    },
    openDrawerOnClick() {

      this.openDrawer = true;
      this.showHoverNavigation = false;
    },
    closeDrawerOnClick() {
      this.openDrawer = false;
      this.showHoverNavigation = false;
    },
    updateSvgColor(id) {
      return;
      [...document.getElementsByClassName("colored")].forEach((elem) => {
        elem.contentDocument.childNodes[1].childNodes[1].innerHTML =
          "\n\t.st0{fill:#ffffff;}\n";
      });
      document.getElementById(
        id
      ).contentDocument.childNodes[1].childNodes[1].innerHTML =
        "\n\t.st0{fill:#000000;}\n";
    },
    expandNavigation(event) {
      // console.log(event.currentTarget);
      if (this.openDrawer) {
        // thi.renderDelayVar = false
        return;
      }
      this.showHoverNavigation = true;
    },
    hideNavigation() {
      // this.renderDelayVar = false
      if (this.openDrawer) {
        return;
      }
      this.showHoverNavigation = false;
    },
    fetchSelectedTab(currentPage) {
      if (
        currentPage == "productList" ||
        currentPage == "addEditProduct" ||
        currentPage == "addNewProduct"
      ) {
        this.selectedTab = "products";
        this.selectedModule = "products";
      }
      if (currentPage == "campaignGroupList" || this.currentRoute.campGrpId) {
        this.selectedTab = "campaign_groups";
        this.selectedModule = "campaigns";
      }
      if (
        currentPage == "addToCampaign" ||
        currentPage == "campaignList" ||
        currentPage == "campaignListPerGroup" ||
        currentPage == "addEditCampaign" ||
        currentPage == "CampaignDetail" ||
        currentPage == "addNewCampaign" ||
        currentPage == "KeywordDetail" ||
        this.currentRoute.campId
      ) {
        this.selectedTab = "campaigns";
        this.selectedModule = "campaigns";
      }
      if (currentPage == "asinScraper" || currentPage == "asinScraperAddForm") {
        this.selectedTab = "asin_scraper";
        this.selectedModule = "products";
      }
      if (currentPage == "tableau3") {
        this.selectedTab = "executive_reporting";
        this.selectedModule = "reports";
      }
      if (
        currentPage == "accounts" ||
        currentPage == "addVendor" ||
        currentPage == "accountDetails" ||
        currentPage == "editBrand" ||
        currentPage == "/accountDetails/profile"
      ) {
        this.selectedTab = "acc_management";
        this.selectedModule = "accounts";
      }
      if (currentPage == "Automation2" || currentPage == "addGuardrail") {
        this.selectedTab = "all_guardrails";
        this.selectedModule = "guardrails";
      }
      if (currentPage == "MyAutomation") {
        this.selectedTab = "my_guardrails";
        this.selectedModule = "guardrails";
      }
      if(currentPage == 'template' || currentPage == 'addTemplate' || currentPage == 'editTemplate'){
        this.selectedTab = "templates"
        this.selectedModule = 'nav_footer'
      }
      if(currentPage == 'releaseNotes' || currentPage=='addNote' || currentPage == 'releaseDetail' || currentPage=='releaseDetail/detail'){
        this.selectedTab = 'resources'
        this.selectedModule = 'nav_footer'
      }
      if(currentPage == 'tagging'){
        this.selectedTab = "tagging_strategy";
        this.selectedModule = "taggingStrategy";
      }
      if(currentPage == 'dspTagList'){
        this.selectedTab = "dsp"
        this.selectedModule = "dsp"
      }
      if (this.selectedTab) {
        return true;
      } else {
        return false;
      }
    },
    tabSelected(item) {
      // selectModule
      this.selectedTab = item.id;
      if (item && item.id == "products") {
        this.selectedModule = "products";
        this.navigateToProducts();
      } else if (item && item.id == "campaign_groups") {
        this.selectedModule = "campaigns";
        this.navigateToCampaignGroup();
      } else if (item && item.id == "campaigns") {
        this.selectedModule = "campaigns";
        this.navigateToCampaign();
      } else if (item && item.id == "dsp") {
        this.selectedModule = "dsp";
        this.navigateToDsp();
      } else if (item && item.id == "asin_scraper") {
        this.selectedModule = "reports";
        this.navigateToProductScraper();
      } else if (item && item.id == "executive_reporting") {
        this.selectedModule = "reports";
        this.navigateToTableau();
      } else if (item && item.id == "acc_management") {
        this.selectedModule = "accounts";
        this.navigateToAccounts();
      } else if (item && item.id == "all_guardrails") {
        this.selectedModule = "guardrails";
        this.navigateToAutomation2();
      }
      else if(item && item.id =="my_guardrails"){
        this.selectedModule = "guardrails";
        this.navigateToMyAutomation();
      }
      else if(item && item.id == 'resources'){
        this.selectedModule = 'nav_footer'
        this.navigateToReleaseNotes()
      }
      else if(item && item.id == 'templates'){
        this.selectedModule = 'nav_footer'
        this.navigateToTemplates()
      }
      else if(item && item.id == 'tagging_strategy'){
        this.selectedModule = 'taggingStrategy'
        this.navigateToTagging();
      }
      else if(item && item.id == 'product_alerts'){
        this.selectedModule = 'productAlerts'
        this.navigateToProductAlerts();
      }
      //for ipads and smaller screen size
      if(window.innerWidth < 769){
        this.closeDrawerOnClick()
      }
      document.getElementById('dropdown_footer').classList.remove('show')
    },
    navigateToAutomation2() {
      if (this.$route.name != "Automation2") {
        this.resetAutomationData();
        this.resetAdvanceFilter();
      }
      this.$store.state.automation.owner = 'All';
      this.$router.push({ path: "/automation2" });
    },
    navigateToMyAutomation(){
      if(this.$route.name !="MyAutomation"){
        this.resetAutomationData();
        this.resetAdvanceFilter();
      }
      this.$store.state.automation.owner = 'Me';
      this.$router.push({path:"/myAutomation"});
    },
    navigateToAccounts() {
      if (this.$route.name != "accounts") {
        this.resetAccountsData();
        this.resetAdvanceFilter();
      }
      this.$router.push({ path: "/accounts" });
    },
    navigateToTableau() {
      this.$router.push({ path: "/tableau3" });
    },
    navigateToProductScraper() {
      if (this.$route.name != "asinScraper") {
        this.resetAsinData();
      }
      this.$router.push({ path: "/asinScraper" });
    },
    navigateToCampaign() {
      if (this.$route.name != "campaignList") {
        this.resetCampData();
        this.resetAdvanceFilter();
      }
      this.$router.push({ path: "/campaignList" });
    },
    navigateToDsp() {
      if (this.$route.name != "dspTagList") {
        this.resetAdvanceFilter();
      }
      this.$router.push({ path: "/dspTagList" });
    },
    navigateToCampaignGroup() {
      if (this.$route.name != "campaignGroupList") {
        this.resetCampGrpData();
        this.selectedPage = "CampaignGroup";
        this.$router.push({ path: "/campaignGroupList" });
      }
    },
    navigateToProducts() {
      if (this.$route.name != "productList") {
        this.resetProdData();
        this.resetAdvanceFilter();
      }
      this.$router.push({ path: "/productList" });
    },
    navigateToTagging() {
      if (this.$route.name != "taggingStrategy") {
        this.resetAccountsData();
        this.resetAdvanceFilter();
      }
      this.$router.push({ path: "/taggingStrategy" });
    },
    navigateToProductAlerts() {
      if (this.$route.name != "productAlerts") {
        // this.resetAccountsData();
        // this.resetAdvanceFilter();
      }
      this.$router.push({ path: "/productAlerts" });
    },
    resetAutomationData() {
      this.$store.state.currentPageNumber = 1;
      this.$store.state.automation.owner = "Me";
      this.$store.state.automation.target = "All";
      this.$store.state.automation.subTarget = null;
      this.$store.state.automation.subTargetValue = null;
    },
    resetAccountsData() {
      this.$store.state.searchFilterString = "";
      this.$store.state.currentPageNumber = 1;
      this.$store.state.selectedSortOrder = {
        field: "date_created",
        order: "desc",
      };
    },
    resetAsinData() {
      this.$store.state.selectedBrandProduct = "";
      this.$store.state.selectedVendorFilter = "";
      this.$store.state.product.actionSelectionControl = false;
      this.$store.state.product.selectedProducts = [];
      this.$store.state.currentPageNumber = 1;
      this.$store.state.searchFilterString = "";
      this.$store.state.selectedSortOrder = {
        field: "updated_on",
        order: "desc",
      };
    },
    resetCampData() {
      this.$store.state.selectedVendorFilter = "";
      this.$store.state.selectedBrandProfle = "";
      this.$store.state.selectedCampaignGroupFilter = "";
      this.$store.state.selectedTag = "";
      this.$store.state.currentPageNumber = 1;
      this.$store.state.searchFilterString = "";
      this.$store.state.selectedSortOrder = { field: "name", order: "asc" };
      this.$store.state.campaign.campaignToAddToGroupList = [];
      this.$store.state.campaign.actionSelectionControl = false;
    },
    resetCampGrpData() {
      this.$store.state.campaign.actionSelectioncampaignGroupControl = false;
      this.$store.state.campaign.campaignGroupSelectedList = [];
      this.$store.state.selectedBrandProfle = "";
      this.$store.state.selectedVendorFilter = "";
      this.$store.state.currentPageNumber = 1;
      this.$store.state.searchFilterString = "";
      this.$store.state.selectedCampaignGroupFilter = "";
      this.$store.state.selectedSortOrder = { field: "name", order: "asc" };
      this.$store.state.clientData = null;
    },
    resetProdData() {
      this.$store.state.product.selectedProducts = [];
      this.$store.state.product.actionSelectionControl = false;
      this.$store.state.searchFilterString = "";
      this.$store.state.selectedVendorProduct = "";
      this.$store.state.selectedBrandProduct = "";
      this.$store.state.currentPageNumber = 1;
      this.$store.state.selectedSortOrder = {
        field: "product_title",
        order: "asc",
      };
    },
    resetAdvanceFilter() {
      this.$store.state.campaign.advanceFilter = {};
      this.$store.state.accountsFilter = [];
      this.$store.state.accounts.advanceFilter = {};
      this.$store.state.campaignsFilter = [];
      this.$store.state.productAdvanceFilter = [];
      this.$store.state.product.productAdvanceFilter = {};
      this.$store.state.automation.advanceFilterAutomation = {};
      this.$store.state.automationFilter = [];
    },
  },
};
</script>


<style lang='scss'>
.navigation_block {
  height: 100%;
  width: 100%;
  background-color: #143a33;
  .nav_icon_hovered{
    background-color:#6FAEDF;border-radius:50%;height:25px;width:25px;border:1px solid #ffffff;
  }
  .nav_icon_unhovered{
    background-color:white;border-radius:50%;height:25px;width:25px;border:1px solid #767676;
  }
  .close_wrapper {
    height: calc(100vh - 170px) !important;
    width: 100%;
  }
  .open_wrapper {
    height: calc(100vh - 170px) !important;
    width: 100%;
  }
  .expand_footer {
    position: absolute;
    bottom: 0px;
    padding-left: 20px;
    height: 92px;
    padding-top:5px;
    width:100%;
    padding-right:25px;
    .name_example{
      cursor: pointer;
      height:28px;
      margin-left:-20px;
      &.selected {
        background-color: #b7dd79;
      }
      .dropdown-menu{
        &.show{
          left:-107px !important;
        }
      }

    }
    .dropdown-toggle:empty::after{
      margin-left: -10px;
      display: none;
    }
    .signature {
      color: #ffffff;
      font-family: 'Poppins';
      font-size: 8px;
      letter-spacing: 0.22px;
      margin-bottom: 2px;
    }
    .user_name {
      color: #ffffff;
      font-family: 'Montserrat';
      font-size: 15px;
      letter-spacing: 0.33px;
      margin-bottom: 3px;
      padding-left:20px;
      &.selected{
        color: #000000 !important;
        font-family: "Nunito Sans" !important;
        font-size: 15px;
        font-weight: bold;
        letter-spacing: 0.33px;
      }
    }
    .signed_in {
      opacity: 0.42;
      color: #ffffff;
      font-family: 'Poppins';
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 0.27px;
      margin-bottom: 0px;
    }

    
  }
  .expand {
      height: 25px;
      width: 25px;
      position:absolute;
      top:71px;
      left:237px;
      cursor:pointer;
      transition: transform 5.5s ease;
      // &.ghost {
      //   padding-right:-25px;
      // }
      &.no_display{
        display: none !important;
      }
    }
  .main_title {
    padding-left: 10px;
    width: 122px;
    color: #ffffff;
    font-family: 'Poppins';
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 1px;
    line-height: 27px;
    text-align: center;
    padding-top: 27px;
  }
  .nav_header {
    height: 84px;
    width: 100%;
    background-color: #115e67;
    margin-left: 0px;
    margin-right: 0px;
    padding-top: 0px;
    padding-left: 30px;
    position: relative;
    &.reducePadding {
      padding-left: 15% !important;
    }
  }
  .nav_header_item {
    min-height: 60px;
    width: 100%;
    margin-left: 0px;
     margin-right: 0px;
    margin-top: 10px;
    padding-left: 0px;
    .close_nav{
      margin:auto ;
    }
    .open_nav{
      margin-left: 20px;
    }
    .sub_heading {
      height: 26px;
      width: 122px;
      color: #ffffff;
      font-family: 'Poppins';
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 0.27px;
      line-height: 18px;
      padding-left: 10px;
      padding-top: 5px;
      text-transform: uppercase;
    }
    .nav_header_tab {
      width: 100%;
      margin: 0px;
      padding-left: 58px;
      height: 28px;
      color: #ffffff;
      font-family: "Nunito Sans";
      font-size: 15px;
      letter-spacing: 0.33px;
      line-height: 20px;
      padding-top: 4px;
      cursor: pointer;
    }
    .nav_header_tab.selected {
      background-color: #b7dd79;
      color: #000000;
      font-family: "Nunito Sans";
      font-size: 15px;
      font-weight: bold;
      letter-spacing: 0.33px;
    }
    .nav_header_tab.hovered{
        background-color: #115E67 !important;
    }
  }
  .nav_header_item.collapse_close {
    text-align: center;
  }
  .nav_header_item.selected {
    background-color: #b7dd79;
    color: #000000;
  }
  .nav_header_item{
    .selected {
      background-color: #b7dd79;
      color: #000000;
      width:100%;
    }
  }
  .st0 {
    fill: #000000;
  }

  .collapse {
    // margin-left: 20px;
    position: absolute;
    top: 71px;
    left:21px;
    height: 25px;
    // width: 25px;
    width:100%;
    cursor: pointer;
    display: block !important;
    text-align:center;
    // &.ghost {
    //   position: relative !important;
    //   cursor: pointer;
    // }
  }
}
</style>